/** Retrieves the main location from the pathname. */
export const getLocationFromPath = (pathname) => {
  const indexOfSecondPath = pathname.indexOf('/', 1);
  return pathname.substring(0, indexOfSecondPath < 0 ? pathname.length : indexOfSecondPath);
};
